import React from "react";
import AsyncSelect from "react-select/async";
import style from "../../assets/css/global-fields.module.scss";
import {FormControl} from "@mui/material";

const GlobalSearchField = ({onSelect, loadOptions, placeH}) => {
  // console.log("loadOptions", loadOptions);
  return (
    <div className={style.proposalSelectField}>
      <FormControl fullWidth className="global-select">
        <AsyncSelect
          cacheOptions
          loadOptions={loadOptions}
          defaultOptions
          onChange={onSelect}
          placeholder={placeH}
          isClearable
          isLoading={false}
        />
      </FormControl>
    </div>
  );
};

export default GlobalSearchField;
